import { GameProps, gamePropsNull } from './game.props'
import { DefendOption } from './defend-option'
import { Game } from './game'

interface DefenderDeclarationGameProps extends GameProps {
  readonly userDefendOptions: DefendOption[]
}

export class DefenderDeclarationGame extends Game {
  public readonly userDefendOptions =
    this.defenderDeclarationGameProps.userDefendOptions

  public constructor(
    private defenderDeclarationGameProps: DefenderDeclarationGameProps,
  ) {
    super(defenderDeclarationGameProps)
  }
}

export const defenderDeclarationGameNull: DefenderDeclarationGame =
  new DefenderDeclarationGame({
    ...gamePropsNull,
    userDefendOptions: [],
  })
